duracion_min: 48
faseProduccion: 0
id: 1
preguntas: 5
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Por qué invertir
